<template>
  <div class="inner">
    <div class="inner_top">
      <div class="inner_title">
        课时明细
        <a-popover arrow-point-at-center placement="bottomLeft">
          <template slot="content">
            <p>每日课时的老师考勤及学生出勤明细</p>
          </template>
          <a-icon class="icon-circle" type="question-circle" />
        </a-popover>
      </div>
      <a-form
        layout="inline"
        :labelCol="{ lg: { span: 5 } }"
        :wrapperCol="{ lg: { span: 18 } }"
        labelAlign="left"
      >
        <div class="ulrow">
          <div class="ulrow_list">
            <a-form-item label="上课日期" class="w100">
              <a-range-picker
                style="width: 100%"
                :disabled-date="disabledDate"
                @change="changeDate"
                format="YYYY-MM-DD"
                v-model="time"
              >
                <a-icon slot="suffixIcon" type="clock-circle" />
              </a-range-picker>
            </a-form-item>
          </div>
          <div class="ulrow_list">
            <a-form-item label="班级名称" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                v-model="xhrParams.className"
                @dropdownVisibleChange="
                  dropdownVisibleChange($event, 'classNameList')
                "
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in classNameList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <div class="ulrow_list">
            <a-form-item label="课程名称" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                v-model="xhrParams.courseName"
                @dropdownVisibleChange="
                  dropdownVisibleChange($event, 'courseNameList')
                "
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in courseNameList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <div class="ulrow_list">
            <a-form-item label="课节名称" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                v-model="xhrParams.lessonName"
                @dropdownVisibleChange="
                  dropdownVisibleChange($event, 'lessonNameList')
                "
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in lessonNameList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <!-- <div class="ulrow_list">
            <a-form-item label="服务学校" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                v-model="xhrParams.serviceSchool"
                @dropdownVisibleChange="dropdownVisibleChange($event, 'serviceSchoolList')"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in serviceSchoolList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div> -->
          <div class="ulrow_list">
            <a-form-item label="课程提供方" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                @change="serviceChange"
                v-model="xhrParams.provider"
                @dropdownVisibleChange="
                  dropdownVisibleChange($event, 'providerList')
                "
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in providerList"
                  :value="item.name"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <!-- <div class="ulrow_list">
            <a-form-item label="上课老师" class="w100">
              <a-select
                allowClear
                show-search
                placeholder="请选择"
                :not-found-content="fetching ? undefined : null"
                v-model="xhrParams.lessonTeacher"
                @dropdownVisibleChange="dropdownVisibleChange($event, 'lessonTeacherList')"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option
                  v-for="(item, index) in lessonTeacherList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div> -->
          <!-- <div class="ulrow_list">
            <a-form-item label="考勤状态" class="w100">
              <a-select allowClear placeholder="请选择" v-model="xhrParams.checkStatus">
                <template v-for="(item, index) in checkStatusText" :value="index">
                  <a-select-option :key="index" v-if="index !== 4">{{ item }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div> -->
          <div class="ulrow_list">
            <div class="search-oper w100">
              <a-button type="primary" @click="queryNewList">查询</a-button>
              <a-button type="primary" @click="clearSelect">重置</a-button>
            </div>
          </div>
        </div>
      </a-form>
    </div>
    <div class="inner_con">
      <div class="flex-between">
        <!-- <h2>统计列表</h2> -->
        <a
          class="download flex-items"
          :class="downLoading ? 'disabled' : ''"
          @click="!downLoading ? exportOrder() : ''"
        >
          <!-- <img v-if="!downLoading" src="/order/exportOrder_icon.png" /> -->
          {{ downLoading ? '导出中...' : 'Excel导出' }}
        </a>
      </div>
      <a-table
        :loading="tableLoading"
        style="margin-top: 24px"
        :columns="columns"
        :data-source="tableData"
        @change="onChange"
        :pagination="pagination"
        :rowKey="getRowKey"
      >
        <!-- 考勤状态 -->
        <!-- <span slot="checkStatus" slot-scope="checkStatus, record">
          <span v-if="checkStatus === -1" class="error">异常</span>
          <span v-else :class="statusClassName[record.checkStatus]">{{
            checkStatusText[checkStatus]
          }}</span>
        </span> -->
        <span slot="teacherName" slot-scope="text, record">{{
          record.teacherName ? text : '暂无'
        }}</span>
        <span slot="checkDate" slot-scope="text, record">{{
          record.checkDate ? text : '暂无'
        }}</span>
        <span slot="count" slot-scope="text">{{ text }}</span>
        <span class="success" slot="actStudentCheckCount" slot-scope="text">{{
          text
        }}</span>
        <span class="info" slot="leaveStudentCount" slot-scope="text">{{
          text
        }}</span>
        <span class="disabled" slot="notCheckStudentCount" slot-scope="text">{{
          text
        }}</span>
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <a
            style="display: block"
            @click="goClassDetail(record.classId, record.courseId, record)"
            >详情</a
          >
        </span>
      </a-table>
    </div>
    <a-spin
      class="fix-spin"
      :spinning="downLoading"
      tip="下载中，请勿操作..."
    />
  </div>
</template>

<script>
import moment from 'moment'
import { getStatisticalListData, getReportParamsList } from '../../api/report'
import CSchoolSelect from '../../components/CSchoolSelect'
import { downloadExcelFile } from '../../utils'
import Vue from 'vue'

export default {
  name: 'statistical',
  data() {
    return {
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      fetching: false,
      columns: [
        {
          title: '日期',
          dataIndex: 'attendDate', // attendDate
        },
        {
          title: '班级名称',
          dataIndex: 'className',
        },
        {
          title: '课程名称',
          dataIndex: 'courseName',
        },
        {
          title: '课节名称',
          dataIndex: 'lessonName',
        },
        {
          title: '课程提供方',
          dataIndex: 'provider',
        },
        {
          title: '上课时间',
          dataIndex: 'lessonTime',
        },
        {
          title: '考勤老师',
          dataIndex: 'teacherName',
          scopedSlots: { customRender: 'teacherName' },
        },
        {
          title: '考勤时间',
          dataIndex: 'checkDate',
          scopedSlots: { customRender: 'checkDate' },
        },
        {
          title: '老师考勤次数',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
        },
        {
          title: '应出勤学生数',
          dataIndex: 'studentCheckCount',
        },
        {
          title: '实点名学生数',
          dataIndex: 'actStudentCheckCount',
          scopedSlots: { customRender: 'actStudentCheckCount' },
        },
        {
          title: '请假学生数',
          dataIndex: 'leaveStudentCount',
          scopedSlots: { customRender: 'leaveStudentCount' },
        },
        {
          title: '未点名学生数',
          dataIndex: 'notCheckStudentCount',
          scopedSlots: { customRender: 'notCheckStudentCount' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: 150,
        },
      ],
      statusClassName: ['', 'success', 'warning', 'disabled', ''],
      checkStatusText: ['待签到', '正常', '请假', '未签到', '其他'],
      schoolList: [],
      time: [],
      xhrParams: {
        currentPage: 1,
        schoolId: undefined,
        startTime: '',
        endTime: '',
        className: undefined,
        courseName: undefined,
        lessonName: undefined,
        provider: undefined,
        sourceType: undefined,
      },
      tableData: [],
      tableLoading: true,
      downLoading: false,
      classNameList: [],
      courseNameList: [],
      providerList: [],
      lessonNameList: [],
    }
  },
  components: {
    CSchoolSelect,
  },
  methods: {
    exportOrder() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.downLoading = true
      downloadExcelFile(
        '/api/pcWeb/report/exportClassHourDetails',
        '课时明细.xlsx',
        _this.xhrParams
      ).then(() => {
        _this.downLoading = false
      })
        },
      })
    },
    changeDate(event) {
      if (!event.length) {
        this.xhrParams.startTime = ''
        this.xhrParams.endTime = ''
        return
      }
      this.xhrParams.startTime = moment(event[0]).format('YYYY-MM-DD')
      this.xhrParams.endTime = moment(event[1]).format('YYYY-MM-DD')
    },
    onChange(pagination, filters, sorter) {
      console.log('pagination', pagination)
      let obj = this.xhrParams
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      this.getListData(obj)
    },
    chooseListValue(index, list, key) {
      this.xhrParams[key] = this[list][index]
    },
    searchHandle(value, list) {
      console.log(value, this[list])
      return this.classNameList.filter((item) => item.includes(value))
    },
    dropdownVisibleChange(type, list) {
      if (type && !this[list].length) {
        this.fetching = true
        setTimeout(() => {
          const key = list.charAt(0).toUpperCase() + list.slice(1)
          this[list] = [...this[`cache${key}`]]
          this.fetching = false
        }, 200)
      }
    },
    clearSelect() {
      this.xhrParams = {
        currentPage: 1,
        startLessonTime: '',
        endLessonTime: '',
        className: undefined,
        courseName: undefined,
        serviceSchool: undefined,
        provider: undefined,
        lessonTeacher: undefined,
        checkStatus: undefined,
      }
      this.time = []
      this.getListData()
    },
    queryNewList() {
      this.xhrParams.currentPage = 1
      this.xhrParams.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.xhrParams
      )}`
      this.getListData(this.xhrParams)
      this.pagination.current = 1
    },
    changePage(page) {
      this.pagination.current = page
    },
    // 控制选择日期范围
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    //订单列表
    async getListData(params) {
      console.log('434---params', params)
      this.xhrParams.schoolId = Vue.ls.get('schoolId')
      this.tableLoading = true
      const data = await getStatisticalListData(params).finally(() => {
        this.tableLoading = false
      })
      console.log('列表-----', data)
      this.tableData = data.data.records
      this.pagination.total = data.data.total
      this.pagination.current = data.data.current
      this.pagination.pageSize = data.data.size
    },

    // 课程提供方下拉
    serviceChange(value) {
      this.providerList.forEach((v) => {
        if (value === v.name) {
          this.xhrParams.provider = v.name
          this.xhrParams.sourceType = v.type
        }
      })
    },

    // 跳转到详情
    goClassDetail(id, courseId, item) {
      this.$router.push({
        name: 'classDetail',
        query: {
          id,
          courseId,
          isReport: item,
        },
      })
    },
    getRowKey(record, index) {
      return index;
    },
    // 获取下拉框数据
    async getReportParamsList(schoolId) {
      const res = await getReportParamsList(schoolId)
      this.classNameList = res.data.className
      this.courseNameList = res.data.courseName
      this.providerList = res.data.serviceProvider
      this.lessonNameList = res.data.lessonName
      console.log('下拉框数据', res)
    },
  },

  created() {
    if (this.$route.query.params) {
      this.xhrParams = JSON.parse(this.$route.query.params)
    } else {
      this.xhrParams = {}
    }
    this.getListData(this.xhrParams)
    this.getReportParamsList(Vue.ls.get('schoolId'))
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
.w100 {
  width: 100%;
}
.inner {
  width: calc(100% - 40px);
  margin: 20px auto;
}
.inner_top {
  background: #fff;
  padding: 20px;
  margin-bottom: 24px;
}
.inner_title {
  color: rgba(16, 16, 16, 100);
  font-size: 20px;
  padding-bottom: 20px;
}
.inner_con {
  background: #fff;
  padding: 20px;
}
.ulrow {
  display: flex;
  flex-wrap: wrap;
}
.ulrow_list {
  width: calc(100% / 4);
  margin-bottom: 15px;
}
.ulrow_list_tuwo {
  width: 50%;
  text-align: right;
}
.inner_con h2 {
  font-size: 16px;
  font-weight: bold;
}

.search-oper {
  width: 100%;
  text-align: right;
  button {
    margin: 0px 5px;
  }
}
.download {
  display: inline-block;
  margin-left: 20px;
  text-decoration: none;
  // color: $primary-color-dark;
  color: #1890ff;
  position: relative;
  font-size: 14px;
}
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
.fix-spin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  padding-top: 50vh;
  color: $green;
}
/deep/ .ant-spin-dot-item {
  background-color: $green;
}
</style>
